import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

// Enterprise wrapper components
import { EnterpriseHeaderComponent } from './shared/enterprise-header/enterprise-header.component'
import { EnterpriseFooterComponent } from './shared/enterprise-footer/enterprise-footer.component'

// Redefine enterprise
import { RedefineHomepageComponent } from './redefine/pages/redefine-homepage/redefine-homepage.component'
import { RedefineContactComponent } from './redefine/pages/redefine-contact/redefine-contact.component'
import { RedefineHeaderComponent } from './redefine/components/redefine-header/redefine-header.component'
import { RedefineFooterComponent } from './redefine/components/redefine-footer/redefine-footer.component'
import { RedefineAboutComponent } from './redefine/pages/redefine-about/redefine-about.component'

@NgModule({
    declarations: [
        // Shared enterprise components
        EnterpriseHeaderComponent,
        EnterpriseFooterComponent,

        // Redefine components
        RedefineHomepageComponent,
        RedefineContactComponent,
        RedefineHeaderComponent,
        RedefineFooterComponent,
        RedefineAboutComponent,
    ],
    imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
    exports: [EnterpriseHeaderComponent, EnterpriseFooterComponent, RedefineHomepageComponent, RedefineContactComponent, RedefineHeaderComponent, RedefineFooterComponent, RedefineAboutComponent],
})
export class EnterprisesModule {}
